module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Unterkulm-3e299ced27052a9a13303b9afba2c2c3.svg";